import { createRootRouteWithContext, Outlet, ScrollRestoration } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { ErrorState } from "@/ui/States";
import { Button } from "@/ui/Button";
export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
  errorComponent: RouteError,
});

function RootLayout() {
  return (
    <>
      <a
        href="#main"
        className="sr-only rounded-[var(--radius-sm)] bg-[var(--surface)] px-3 py-2 text-[var(--text-sm)] focus:not-sr-only focus:absolute focus:left-3 focus:top-3 focus:z-50"
      >
        Skip to content
      </a>
      <ScrollRestoration />
      <Outlet />
    </>
  );
}

function NotFound() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 px-6 text-center">
      <p className="mono text-[11px] uppercase tracking-widest text-[var(--text-muted)]">404</p>
      <h1 className="text-xl font-semibold">This page does not exist</h1>
      <p className="max-w-sm text-sm text-[var(--text-secondary)]">
        The link may be out of date, or the resource may have been removed.
      </p>
      <Button tone="secondary" onClick={() => window.location.assign("/")}>
        Go to the dashboard
      </Button>
    </div>
  );
}

function RouteError({ error }: { error: Error }) {
  return (
    <div className="mx-auto flex min-h-dvh max-w-lg flex-col items-center justify-center px-6">
      <ErrorState error={error} onRetry={() => window.location.reload()} />
    </div>
  );
}
